<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="9"
    viewBox="0 0 11 9"
  >
    <path
      fill="none"
      fill-rule="evenodd"
      stroke="#5CD18A"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M0 3.518L2.532 6.26 8.313 0"
      transform="translate(1.299 1.404)"
    />
  </svg>
</template>